export default {"src":"/_next/static/media/setting.00b4a534.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};